



























import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { VFields } from '@/models/v-fields';
import { FaxLine, ForwardingNumber } from '@/models/admin/store';
import { Base } from '@/components/common/base';
import { storeService, userService } from '@/shared';
import { Utils } from '@/helper/utils';
import { mapGetters } from 'vuex';

@Component({
  props: ['methodName', 'progress'],
  computed: {
    ...mapGetters({ dashboardDetails: 'getDashboardDetails' }),
    methodtoCall: {
      get() {
        return this.$props.methodName;
      },
    },
  },
})
export default class SaveStoreIPPage extends Base {
  public form: any = {};
  public storeIpFields: Array<VFields<any>> = [];
  public storeIpModel = {
    id:'',
    name:'',
    fromIp: '',
    toIp: '',
  };
  public dateTime: any;
  public storeId: number = 0;
  public requestProgress: boolean = false;

  public callMethod(methodName): void {
    if (methodName === 'backToStoreEdit') {
      this.$router
        .push({
          name: 'admin.stores.edit',
          params: { id: this.storeId.toString(), tab: 'StoreIpRestrict' },
        })
        .catch((ex) => {
          console.log(ex);
        });
    }
    if (methodName === 'saveStoreIp') {
      if (!this.form.$valid) {
        this.showAlert(false, 'Form is Invalid!');
        this.resetMethodName(methodName);
        return;
      }
      this.saveStoreIp();
    }
    this.resetMethodName(methodName);
  }
  public resetMethodName(methodName): void {
    if (methodName !== '') {
      this.$emit('resetMethodName', methodName);
    }
  }
  public updateToolBar(): void {
    const buttons: any = [];
    if (this.storeId) {
      buttons.push({
        id: '0',
        type: 'button',
        title: this.$parent.$t('stores.btnBackToStoreTitle'),
        disabled: false,
        visible: true,
        class: 'btn',
        label: this.$parent.$t('stores.btnBack'),
        click: 'backToStoreEdit',
        icon: 'fas fa-arrow-left',
      });
    }
    this.$emit('updateToolBar', buttons);
  }
  public mounted() {
    this.storeId = Number(this.$route.params.storeId);
    this.setStoreIpFields();

    if(this.$route.params.nameId){
      this.getIpRange();
    }
    else{
      this.getDateTime();
      this.getStoreName();
    }
    
    // Toolbar
    this.updateToolBar();
    this.$watch('methodtoCall', (newVal, oldVal) => {
      if (newVal) {
        this.callMethod(newVal);
      }
    });
  }

  public setStoreIpFields(): void {
    this.storeIpFields = [
      {
        key: 'name',
        type: 'v-alynk-text-field',
        required: true,
        templateOptions: {
          disabled: false,
          label: 'Name',
          required: true,
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 float-left',
          rules:[
            v => this.required('Name',v)
          ]
        },
      },
      {
        key: 'fromIp',
        type: 'v-alynk-text-field',
        required: true,
        templateOptions: {
          disabled: false,
          label: 'Ip Range From',
          loading: false,
          required: true,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 float-left',
          rules:[
            v => this.required('Ip Range From',v)
          ]
        },
      },
      {
        key: 'toIp',
        required: true,
        type: 'v-alynk-text-field',
        templateOptions: {
          disabled: false,
          label: 'Ip Range To',
          loading: false,
          required: true,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 float-left',
          rules:[
            v => this.required('Ip Range To',v)
          ]
        },
      },
    ];
  }

  public async getIpRange(): Promise<void> {
    try {
      this.formlyShowSkeleton(this.storeIpFields);
      const response = await storeService.getIpRange(this.storeId);
      const selectedId =  response.storeJson.allowedIPs.find(
        (m) => m.id == this.$route.params.nameId
      );
      this.storeIpModel = selectedId;
    } finally {
      this.formlyHideSkeleton(this.storeIpFields);
    }
  }

  public getDateTime(): void {
    this.dateTime = this.$moment().format('YYYYMMDDhhmmss');
  }

  public async getStoreName(){
    try{
      this.formlyShowSkeleton(this.storeIpFields);
      const response = await storeService.getStoreName();
      
      const currentStore = response.results.filter(x => x.id == this.storeId);
      const storeName = currentStore.map((item) => { 
        return item.name;
      });
      this.storeIpModel.name =  storeName + '_' + this.dateTime;
    }finally{
      this.formlyHideSkeleton(this.storeIpFields);
    }
  }
  
  public validateStoreIP(): Vue & { validate: () => boolean } {
    return this.$refs.storeIpForm as Vue & { validate: () => boolean };
  }

  public async saveStoreIp(): Promise<void> {
    if(this.validateStoreIP().validate()){
      try {
        this.requestProgress = true;
        this.$emit('update:progress', this.requestProgress);
        if (this.storeIpModel.id == '') {
          await storeService.saveStoreIp(this.storeId, this.storeIpModel);
          this.showAlert(true, 'Store IP Added successfully');
          this.$router
            .push({
              name: 'admin.stores.edit',
              params:{
                tab: 'StoreIpRestrict'
              }
            })
            .catch((ex) => {
              console.log(ex);
            });
        }
        else{
          await storeService.updateStoreIP(this.storeId, this.storeIpModel);
          this.showAlert(true, 'Store IP Updated successfully');
          this.$router .push({
            name: 'admin.stores.edit',
            params: {
              storeId: this.storeId.toString(),
              tab: 'StoreIpRestrict'
            },
          })
          .catch((ex) => {
            console.log(ex);
          });
        }
      } 
      finally {
        this.requestProgress = false;
        this.$emit('update:progress', this.requestProgress);
      }
    }
  }
}
